import { render, staticRenderFns } from "./mentally-adapt.vue?vue&type=template&id=af232d4c&scoped=true"
import script from "./mentally-adapt.vue?vue&type=script&lang=js"
export * from "./mentally-adapt.vue?vue&type=script&lang=js"
import style0 from "./mentally-adapt.vue?vue&type=style&index=0&id=af232d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af232d4c",
  null
  
)

export default component.exports